import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import type { CreateProductResponseDto } from "../../dtos/create-product-response-dto";
import type { EditProductRequestDto } from "../../dtos/edit-product-request-dto";
import { ProductService } from "../../services/product-service";

type UsePostEditProductMutationParams = {
  options?: UseMutationOptions<
    CreateProductResponseDto,
    unknown,
    EditProductRequestDto
  >;
};

export const usePostEditProductMutation = ({
  options
}: UsePostEditProductMutationParams = {}) => {
  return useMutation({
    mutationFn: async (payload) => {
      return await ProductService.editProduct({ payload });
    },
    ...options
  });
};
